import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import React from 'react'
import Sheet from 'components/utils/Sheet'
import BodyText from 'LuxKit/Typography/BodyText'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import TripLandingPageWhatOurTravellersSay from './TripLandingPageWhatOurTravellersSay'
import TripLandingTheresMoreAnimatedBackground from 'tripPlanner/Tripkit/TripLandingTheresMoreAnimatedBackground'

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(32)};
  
  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const StyledSheet = styled(Sheet)`
  display: grid;
  grid-template: "content" 1fr / 1fr;
  position: relative;
  min-height: 100%;
  width: 100%;
`

const StyledTripLandingAnimatedBackground = styled(TripLandingTheresMoreAnimatedBackground)`
  grid-area: content;
  position: absolute;
  top: ${rem(-48)};
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
`

const ContentContainer = styled.div`
  grid-area: content;
  position: relative;
  z-index: 1;
  min-height: 100%;
  width: 100%;
`
const StyledSheetTransparent = styled(Sheet)`
  background: rgba(255,255,255, 0.16);
`

function TripLandingPageAndTheresMore() {
  return (
    <StyledSheet paletteType="inverse" background="neutral-eight">
      <StyledTripLandingAnimatedBackground />
      <ContentContainer>
        <Sheet padding="48 0 48 0">
          <LayoutContainer>
            <Group direction="vertical" verticalAlign="center" horizontalAlign="center" gap={32}>
              <HeadingTextBlock variant="heading2"> And there's more... </HeadingTextBlock>
              <GridContainer>
                <StyledSheetTransparent
                  paletteType="inverse"
                  padding="24 20"
                  borderRadius="L"
                >
                  <Group direction="vertical" horizontalAlign="center" gap={24}>
                    <ResponsiveImage id="s98iv3aizbgamsisq8i" />
                    <VerticalSpacer gap={4}>
                      <Group direction="vertical" horizontalAlign="center" gap={4}>
                        <Heading variant="heading5" align="center">Store all your travel docs</Heading>
                        <BodyText variant="large" align="center">
                          TripPlanner keeps all your travel essentials in one spot like tickets, bookings, confirmation numbers, and notes.
                        </BodyText>
                      </Group>
                    </VerticalSpacer>
                  </Group>

                </StyledSheetTransparent>
                <StyledSheetTransparent
                  paletteType="inverse"
                  padding="24 20"
                  borderRadius="L"
                >
                  <Group direction="vertical" horizontalAlign="center" gap={24}>
                    <ResponsiveImage id="3fbe5uaqz82gk7ckef1g" />
                    <VerticalSpacer gap={4}>
                      <Group direction="vertical" horizontalAlign="center" gap={4}>
                        <Heading variant="heading5" align="center"> Smarter maps, smoother days</Heading>
                        <BodyText variant="large" align="center">
                          Visualise your trip with a live, interactive map with estimated times between stops.
                        </BodyText>
                      </Group>
                    </VerticalSpacer>
                  </Group>
                </StyledSheetTransparent>
                <StyledSheetTransparent
                  paletteType="inverse"
                  padding="24 20"
                  borderRadius="L"
                >
                  <Group direction="vertical" horizontalAlign="center" gap={24}>
                    <ResponsiveImage id="6gw6zqyppb6uhblvyonf" />
                    <VerticalSpacer gap={4}>
                      <Group direction="vertical" horizontalAlign="center" gap={4}>
                        <Heading variant="heading5" align="center">Discover what's nearby</Heading>
                        <BodyText variant="large" align="center">
                          We'll show you what's worth seeing, tasting, or trying near each stop. You can make the most of every moment without the extra planning.
                        </BodyText>
                      </Group>
                    </VerticalSpacer>
                  </Group>
                </StyledSheetTransparent>
              </GridContainer>
            </Group>
          </LayoutContainer>
        </Sheet>
        <TripLandingPageWhatOurTravellersSay />
      </ContentContainer>
    </StyledSheet>

  )
}

export default TripLandingPageAndTheresMore
